module.exports = __webpack_public_path__ + "img/guizhouHints_14.aa1643f3.jpg";